import { render, staticRenderFns } from "./Dashboards_800.vue?vue&type=template&id=33d7697a&scoped=true&"
import script from "./Dashboards_800.vue?vue&type=script&lang=js&"
export * from "./Dashboards_800.vue?vue&type=script&lang=js&"
import style0 from "./Dashboards_800.vue?vue&type=style&index=0&id=33d7697a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d7697a",
  null
  
)

export default component.exports